import React from "react"
import Styles from "./rightArea.less"
import RightNav from "./nav/rightNav"
import RightContent from "./content/rightContent"
import ShowDataList from "../../../function/hooks/showDataList"
const TDARightArea = () => {
    const showDataList = ShowDataList()
    return (
        <div style={{display: showDataList.value ? "flex" : "none"}} className={Styles.TDA_RIGHT_BOX}>
            <RightNav />
            <RightContent />
        </div>
    )
}
export default TDARightArea
